module.exports = __webpack_public_path__ + "img/weight2.7bc61e68.svg";